import { Header, Space, Spacer, SubText } from '@procurify/ui'

import { FormattedShortDate } from '@webapp/core/components/FormattedDate'
import { FormattedTime } from '@webapp/core/components/FormattedTime'
import { useProcurifyIntl } from '@webapp/hooks'
import { AuditLogRecordChange } from '@webapp/platform/audit-log/components/AuditLogRecordChange'
import { AuditLogRecordLabel } from '@webapp/platform/audit-log/components/AuditLogRecordLabel'
import { type AuditLogChangedField } from '@webapp/platform/audit-log/entities/AuditLogChangedField'
import { type AuditLogStatusEnum } from '@webapp/platform/audit-log/entities/enums/AuditLogStatusEnum'
import messages from './messages'
import { AuditLogRecordStyled } from './styles/AuditLogRecordStyled'

export interface IAuditLogRecordProps {
  status: AuditLogStatusEnum
  title: string
  userName: string
  changedOn: Date
  changedFields: AuditLogChangedField[]
  delegateeUserName?: string
}

export const AuditLogRecord = ({
  status,
  title,
  userName,
  changedOn,
  changedFields,
  delegateeUserName,
}: IAuditLogRecordProps) => {
  const intl = useProcurifyIntl()
  return (
    <AuditLogRecordStyled status={status}>
      <AuditLogRecordLabel status={status} />

      <Space size='xsmall'>
        <Header as='h5'>{title}</Header>
        <SubText inline color='textSecondary'>
          {delegateeUserName ? (
            intl.formatMessage(messages.delegateeDetail, {
              delegateeUserName,
              userName,
            })
          ) : (
            <strong>{userName}</strong>
          )}
          {' | '}
          <SubText inline bold color='textSecondary'>
            <FormattedShortDate date={changedOn} />{' '}
            <FormattedTime date={changedOn} />
          </SubText>
        </SubText>
      </Space>

      {changedFields && changedFields.length > 0 && (
        <>
          <Spacer />

          <Space size='small'>
            {changedFields.map((record) => (
              <AuditLogRecordChange key={record.field} {...record} />
            ))}
          </Space>
        </>
      )}
    </AuditLogRecordStyled>
  )
}
